
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./request.cjs.production.min.js')
} else {
  module.exports = require('./request.cjs.development.js')
}
